export const SUCCESS = "app/SUCCESS";
export const ERROR = "app/ERROR";
export const GET_IS_AUTH = "app/GET_IS_AUTH";

const initialState = {
  isAuth: null,
  hasRole: null,
  errors: null,
};

// next line is excluded from a sonar because an order of variables is provided by redux
// prettier-ignore
export default (state = initialState, { type, payload }) => { //NOSONAR
  switch (type) {
    case SUCCESS:
      return {
        ...state,
        isAuth: true,
        hasRole: payload.hasDmpRole
      };
    case ERROR:
      return {
        ...state,
        isAuth: false,
        hasRole: false,
        errors: payload
      };
    case GET_IS_AUTH:
      return { ...state, isAuth: true, hasRole: payload.hasDmpRole };
    default:
      return state;
  }
};
